import { FormBuilder, FormGroup } from '@angular/forms';

export class ApplicationListApplicationTabFormModel {

    public form: FormGroup;

    constructor(private formBuilder: FormBuilder) {
        this.form = this.formBuilder.group({
            name: ['']
        });
    }

    decode(data: any) {
        this.form.controls.name.setValue(data.legalName);
    }

    encode(): any {
        return {
            'criteria': this.form.controls.name.value ? this.form.controls.name.value : ''
        };
    }

    get oForm () { return this.form.controls; }
}
